import { UrlConstants } from "../url.constants";
export class ApiPropertyValuationValuationPropertyAppealConstants {
    static URL = UrlConstants.API_V2 + "PropertyValuationPropertyAppeal";
    static FUNCTION_ACCEPT_APPEAL = "AcceptAppeal";
    static FUNCTION_REJECT_APPEAL = "RejectAppeal";
}
